enum ReminderUnitTypes {
  Minute = 'minute',
  Hour = 'hour',
  Day = 'day',
};

export default ReminderUnitTypes;
